import wishlistReducer from "./wishlistReducer";

export const wishlistReducers = {
  wishlist: wishlistReducer,
};
